var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useTable, useSortBy, usePagination } from 'react-table';
import { usePreservedTableContext } from '../../contexts';
var SortableTableCtx = React.createContext({});
var SortableTableProvider = function (_a) {
    var children = _a.children, data = _a.data, columns = _a.columns, initialState = _a.initialState, disableSort = _a.disableSort, paginated = _a.paginated, _b = _a.pageSizeOptions, pageSizeOptions = _b === void 0 ? [] : _b, preservedTableId = _a.preservedTableId;
    var _c = usePreservedTableContext(), preservedTables = _c.preservedTables, setTableState = _c.setTableState;
    var _d = useTable({
        columns: columns,
        data: data,
        initialState: __assign(__assign({ pageSize: 20 }, (preservedTableId && preservedTables[preservedTableId]
            ? preservedTables[preservedTableId]
            : initialState !== null && initialState !== void 0 ? initialState : {})), { pageIndex: 0 }),
    }, useSortBy, usePagination), getTableProps = _d.getTableProps, getTableBodyProps = _d.getTableBodyProps, headerGroups = _d.headerGroups, rows = _d.rows, prepareRow = _d.prepareRow, page = _d.page, pageCount = _d.pageCount, setPageSize = _d.setPageSize, nextPage = _d.nextPage, canNextPage = _d.canNextPage, previousPage = _d.previousPage, canPreviousPage = _d.canPreviousPage, tableState = _d.state;
    var pageIndex = tableState.pageIndex, pageSize = tableState.pageSize;
    useEffect(function () {
        if (preservedTableId) {
            setTableState(preservedTableId, tableState);
        }
    }, [preservedTableId, tableState]);
    // const modified = React.cloneElement()
    var value = React.useMemo(function () { return ({
        getTableProps: getTableProps,
        getTableBodyProps: getTableBodyProps,
        headerGroups: headerGroups,
        rows: rows,
        columns: columns,
        prepareRow: prepareRow,
        disableSort: disableSort,
        page: page,
        pageSize: pageSize,
        pageIndex: pageIndex,
        pageCount: pageCount,
        setPageSize: setPageSize,
        nextPage: nextPage,
        canNextPage: canNextPage,
        previousPage: previousPage,
        canPreviousPage: canPreviousPage,
        paginated: paginated,
        pageSizeOptions: pageSizeOptions,
    }); }, [
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        columns,
        prepareRow,
        disableSort,
        page,
        setPageSize,
        nextPage,
        canNextPage,
        previousPage,
        canPreviousPage,
        paginated,
        pageCount,
        initialState,
        pageSizeOptions,
    ]);
    return _jsx(SortableTableCtx.Provider, __assign({ value: value }, { children: children }));
};
var useSortableTable = function () {
    var context = React.useContext(SortableTableCtx);
    if (context === undefined) {
        throw new Error('useSortableTable must be used within a TableProvider');
    }
    return context;
};
export { SortableTableProvider, useSortableTable };
